import { createSelector } from 'reselect';
import get from 'lodash/get';

export const reqAllUsersSelector = state => state.board.reqAllUsers;

export const usersSelector = createSelector(
  reqAllUsersSelector,
  users => get(users, 'list', []),
);

export const sendingSelector = createSelector(
  reqAllUsersSelector,
  request => get(request, 'sending') || false,
);

export const succeedSelector = createSelector(
  reqAllUsersSelector,
  request => get(request, 'succeed') || false,
);

export const notInCircleMemberSelector = createSelector(
  usersSelector,
  users => {
    return users.map(user => {
      return {
        ...user,
        provider: true,
      };
    });
  },
);



// WEBPACK FOOTER //
// ./src/redux/board/selectors/AllUsers.js